import { Component, Inject, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StatusConstant } from '../status/status-constant';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';

@Component({
  selector: 'app-commontrainning-video',
  templateUrl: './commontrainning-video.component.html',
  styleUrls: ['./commontrainning-video.component.scss']
})

export class CommonTrainingComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any = [] = [];
  spinner: boolean = false;
  OfficeIDList: any = [] = [];
  myOfficeID: any;
  componentList: any[] = [];
  safeSrcVedio!: SafeResourceUrl;
  trainingContentList: any = [] = [];
  paginatorTotalLength: number = 0;
  categories: any = [] = [];
  leveType: number = 0;
  totalCount: number = 0;
  isAll: boolean = true;
  expandedSection: number | null = 0;
  selectedVideoFilter = 1;
  isGroup: boolean = false;
  textTile: string = "All Videos";
  searchTerm: string = '';
  filteredTrainingContentList: any[] = [];
  filteredCategories: any[] = [];

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<CommonTrainingComponent>,
    private encryptionAlgo: EncryptionService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,private formService: FormsService,
    private sanitizer: DomSanitizer) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }



  ngOnInit(): void {
    this.getAllTrainingContent();
  }

  getAllTrainingContent(): void {
    const reqModel = {
      pageIndex: 0,
      pageSize: 10000,
      sortColumn: '',
      sortDirection: '',
      isActive: true,
      level: this.leveType,
      isAll: this.isAll,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    };
    this.formService.getAllTrainingContent(reqModel).subscribe(
      (response: any) => {
        if (response && response.status === this.statusConst.statusSuccess && response.data != null) {
          this.responseHolder = response;
          this.categories = response.data.categories || [];
          this.expandedSection = this.categories.length > 0 ? 0 : null;
          this.trainingContentList = response.data.contents || [];
          this.totalCount = response.data.contents.length;

        } else {
          this.trainingContentList = [];
          this.categories = [];
        }
        this.searchTerm = '';
        this.applyFilter();
      },
      (error: any) => {
        this.trainingContentList = [];
        this.categories = [];
        this.searchTerm = '';
        this.applyFilter();
      }
    );
  }

  applyFilter(): void {
    const term = (this.searchTerm || '').trim().toLowerCase();

    if (!term) {
      this.filteredTrainingContentList = this.trainingContentList;
      this.filteredCategories = this.categories;
      return;
    }

    this.filteredTrainingContentList = this.trainingContentList.filter(
      (content: any) => (content.title || '').toLowerCase().includes(term)
    );

    this.filteredCategories = this.categories
      .map((category: any) => ({
        ...category,
        contents: (category.contents || []).filter(
          (content: any) => (content.title || '').toLowerCase().includes(term)
        )
      }))
      .filter((category: any) => category.contents.length > 0);

    this.expandedSection = this.filteredCategories.length > 0 ? 0 : null;
  }

  onSearchChange(): void {
    this.applyFilter();
  }

  getVisibleCount(): number {
    if (this.isGroup) {
      return this.filteredCategories.reduce(
        (sum: number, category: any) => sum + category.contents.length, 0
      );
    }
    return this.filteredTrainingContentList.length;
  }

  toggleSection(index: number): void {
    this.expandedSection =
      this.expandedSection === index ? null : index;
  }

  getDuration(seconds: number): string {

    if (!seconds || seconds <= 0) {
      return '0m';
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds}s`;
    }

    if (remainingSeconds === 0) {
      return `${minutes}m`;
    }

    return `${minutes}m ${remainingSeconds}s`;
  }

  getContentDuration(seconds: number): string {

    if (!seconds || seconds <= 0) {
      return '0 min';
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes === 0) {
      return `${remainingSeconds} sec`;
    }

    if (remainingSeconds === 0) {
      return `${minutes} min`;
    }

    return `${minutes} min ${remainingSeconds} sec`;
  }

  openVedioLink(link: any, templateRef: TemplateRef<any>) {
    //For Guid
    if (link.contentType == 0) {

      const videoUrl = link.url;

      const embedUrl = this.getguidEmbedUrl(videoUrl);

      this.safeSrcVedio = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);

      this.dialogRef = this.dialog.open(templateRef, {
        panelClass: 'training-video-preview-modalbox',
        disableClose: true,
        width: '90vw',
        maxWidth: '1000px',
        maxHeight: '95vh'
      });
    }

    // For Video
    if (link.contentType == 1) {

      const videoUrl = link.url;

      const embedUrl = this.getVideoEmbedUrl(videoUrl);

      this.safeSrcVedio = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);

      this.dialogRef = this.dialog.open(templateRef, {
        panelClass: 'training-video-preview-modalbox',
        disableClose: true,
        width: '90vw',
        maxWidth: '1000px',
        maxHeight: '95vh'
      });
    }

    //For WebURL
    if (link.contentType == 9) {

      const videoUrl = link.url;

      const embedUrl = this.getguidEmbedUrl(videoUrl);

      this.safeSrcVedio = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);

      this.dialogRef = this.dialog.open(templateRef, {
         panelClass: 'training-video-preview-modalbox',
          disableClose: true,
          width: '90vw',
          maxWidth: '1000px',
          maxHeight: '95vh'
      });
    }

  }

  getguidEmbedUrl(url: string): string {

    if (!url) {
      return '';
    }

    // Already an embed URL
    if (url.includes('embed.app.guidde.com')) {
      return url;
    }

    // Normal Guidde share URL
    if (url.includes('app.guidde.com/share/playbooks/')) {

      const playbookId =
        url.split('/playbooks/')[1]?.split('?')[0];

      return `https://embed.app.guidde.com/playbooks/${playbookId}?mode=videoAndDoc`;
    }

    return url;
  }

  getVideoEmbedUrl(url: string): string {

    if (!url) {
      return '';
    }

    try {

      const urlObj = new URL(url);
      const host = urlObj.hostname.toLowerCase();

      // =========================
      // YouTube
      // =========================
      if (host.includes('youtube.com') || host === 'youtu.be') {

        let videoId = '';

        if (host === 'youtu.be') {
          videoId = urlObj.pathname.substring(1);
        }
        else if (urlObj.pathname === '/watch') {
          videoId = urlObj.searchParams.get('v') || '';
        }
        else if (urlObj.pathname.startsWith('/shorts/')) {
          videoId = urlObj.pathname.split('/shorts/')[1];
        }
        else if (urlObj.pathname.startsWith('/embed/')) {
          videoId = urlObj.pathname.split('/embed/')[1];
        }
        else if (urlObj.pathname.startsWith('/live/')) {
          videoId = urlObj.pathname.split('/live/')[1];
        }

        if (videoId) {
          videoId = videoId.split('?')[0].split('&')[0];

          return `https://www.youtube.com/embed/${videoId}`;
        }
      }

      // =========================
      // ScreenPal
      // =========================
      if (host.includes('screenpal.com')) {

        // Already player URL
        if (urlObj.pathname.startsWith('/player/')) {
          return url;
        }

        const parts = urlObj.pathname.split('/').filter(x => x);

        const videoId = parts[parts.length - 1];

        if (videoId) {
          return `https://go.screenpal.com/player/${videoId}`;
        }
      }

      // =========================
      // Vimeo
      // =========================
      if (host.includes('vimeo.com')) {

        const parts = urlObj.pathname.split('/').filter(x => x);

        const videoId = parts[parts.length - 1];

        if (videoId) {
          return `https://player.vimeo.com/video/${videoId}`;
        }
      }

      // =========================
      // Other video URL
      // =========================
      return url;

    } catch (error) {
      return url;
    }
  }


  onVideoFilterChange(value: number): void {
    this.selectedVideoFilter = Number(value);
    // // For Custom Workflows
    // if(this.selectedVideoFilter==0){
    //   this.textTile="Custom Workflows";
    //   this.leveType=0;
    //   this.CustomWorkFlow=true;
    //   this.isAll=true;
    //   this.getAllTrainingContent();
    // }
    // For All Videos
    if (this.selectedVideoFilter == 1) {
      this.textTile = "All Videos";
      this.leveType = 0;
      this.isGroup = false;
      this.isAll = true;
      this.getAllTrainingContent();
    }
    // For Global Videos
    if (this.selectedVideoFilter == 2) {
      this.textTile = "Global Videos";
      this.leveType = 1;
      this.isGroup = true;
      this.isAll = false;
      this.getAllTrainingContent();
    }
    // For  Organization Videos
    if (this.selectedVideoFilter == 3) {
      this.textTile = "Organization Videos";
      this.leveType = 2;
      this.isGroup = true;
      this.isAll = false;
      this.getAllTrainingContent();
    }
    // For  Location Videos
    if (this.selectedVideoFilter == 4) {
      this.textTile = "Location Videos";
      this.leveType = 0;
      this.isGroup = true;
      this.isAll = false;
      this.getAllTrainingContent();
    }
  }

   close() {
    this.dialogRef.close();
  }

   closeTraining() {
    this.dialog.closeAll();
  }

}
